import angular from 'angular';
import { MovimientoFraccionadoFormComponent, translationKeys } from './form.component';
import './form.scss';
import spaI18N from 'core/i18n';

export * from './form.component';

export default angular.module('spa.movimientos-fraccionados.form', [
  'ui',
  spaI18N
])
  .config(config)
  .component(MovimientoFraccionadoFormComponent.selector, MovimientoFraccionadoFormComponent)
  .name;

config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider
    .state('home.movimientos-fraccionados.new', {
      url: '/new',
      template: '<movimiento-fraccionado-form translations="$resolve.translations"></movimiento-fraccionado-form>',
      resolve: {
        translations
      },
      access: {
        requiresLogin: true
      },
      ncyBreadcrumb: {
        parent: 'home.movimientos-fraccionados.list',
        label: 'Nuevo'
      }
    })
    .state('home.movimientos-fraccionados.uid', {
      url: '/:uid',
      abstract: true,
      template: '<ui-view></ui-view>',
      ncyBreadcrumb: {
        skip: true
      }
    })
    .state('home.movimientos-fraccionados.uid.edit', {
      url: '/edit',
      template: '<movimiento-fraccionado-form translations="$resolve.translations"></movimiento-fraccionado-form>',
      resolve: {
        translations
      },
      access: {
        requiresLogin: true
      },
      ncyBreadcrumb: {
        parent: 'home.movimientos-fraccionados.list',
        label: 'Editar'
      }
    })
    .state('home.movimientos-fraccionados.uid.view', {
      url: '/view',
      template: '<movimiento-fraccionado-form translations="$resolve.translations" view="true"></movimiento-fraccionado-form>',
      resolve: {
        translations
      },
      access: {
        requiresLogin: true
      },
      ncyBreadcrumb: {
        parent: 'home.movimientos-fraccionados.list',
        label: 'Ver'
      }
    });
}

translations.$inject = ['LangService'];

function translations(LangService) {
  return LangService.getTranslations(translationKeys);
}


// WEBPACK FOOTER //
// ./src/components/movimientos-fraccionados/form/index.js